// extracted by mini-css-extract-plugin
export default {"list":"FinanceActivationTables_list__UZiBK"};